import { call, put, select, takeEvery } from "redux-saga/effects";

import { GeocodeResult } from "@mapmycustomers/shared/types/base/Located";
import Organization from "@mapmycustomers/shared/types/Organization";
import { convertLongLatToGeoPoint } from "@mapmycustomers/shared/util/geo/GeoService";

import { callApi } from "@app/store/api/callApi";
import { handleError } from "@app/store/errors/actions";
import { getOrganizationId } from "@app/store/iam";

import { geocodeAddress, reverseGeocodeAddress } from "./actions";

export function* onGeocodeAddress({ payload }: ReturnType<typeof geocodeAddress>) {
  try {
    const orgId: Organization["id"] = yield select(getOrganizationId);
    const response: GeocodeResult = yield callApi("geocodeAddress", orgId, payload.address);
    yield call(payload.callback, response);
  } catch (error) {
    if (payload.failureCallback) {
      yield call(payload.failureCallback);
    }
    yield put(handleError({ error }));
  }
}

export function* onReverseGeocodeAddress({ payload }: ReturnType<typeof reverseGeocodeAddress>) {
  try {
    const orgId: Organization["id"] = yield select(getOrganizationId);
    const result: GeocodeResult = yield callApi(
      "reverseGeocodeAddress",
      orgId,
      convertLongLatToGeoPoint(payload.coordinates)
    );
    yield call(payload.callback, result);
  } catch (error) {
    if (payload.failureCallback) {
      yield call(payload.failureCallback);
    }
    yield put(handleError({ error }));
  }
}

export function* locationSaga() {
  yield takeEvery(geocodeAddress, onGeocodeAddress);
  yield takeEvery(reverseGeocodeAddress, onReverseGeocodeAddress);
}
